import angular from 'angular';

import template from './modal-dialog.html';

angular.module('myConsultApp').directive('modalDialog', () => {
  return {
    template,
    restrict: 'E',
    scope: {
      options: '=',
    },
    link: ($scope) => {
      // Example options object:
      // {
      //   heading: 'heading',
      //   message: 'message',
      //   buttons: [
      //     {
      //       label: 'OK',
      //       href: '#',
      //       clickFn: () => {},
      //     },
      //     {
      //       label: 'Cancel',
      //       href: '#',
      //       clickFn: () => {},
      //     },
      //   ],
      // };

      $scope.isObject = (obj) => {
        return typeof obj === 'object';
      };
    },
  };
});
